import { IMqttMessage } from 'ngx-mqtt';
import { DeviceStatusResponseModel } from 'src/app/models/device/device-status-response.model';
import { SensorTelemetryResponseModel } from 'src/app/models/device/sensor-telemetry-response.mode';

export enum MqttMessageType {
  None = 0,
  DeviceStatus = 1,
  SensorValues = 2,
  ItemUpdate = 3,
  FlowChartDebugStatus = 4,
  FlowChartSyncStatus = 5
}

export interface EmqxRecieveMessageModel {
  topic: string;
  message: IMqttMessage;
  payload: Map<string, any>;
  type: MqttMessageType;
  updatedItemId?: string;
  deviceStatus?: DeviceStatusResponseModel;
  sensorValues?: SensorTelemetryResponseModel[];
}
